import { useSelector } from 'react-redux';

export const useBettingVis = () => {
    return useSelector((state) => state.bettingVis);
};